import { FETCH_ORDER_REFUND_STATUSES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_ORDER_REFUND_STATUSES:
      return action.payload
    default:
      return state
  }
}
